import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type { UserReference } from '@recruitee/account-types';
import type { CandidateReference } from '@recruitee/candidate-types';
import type { GdprRequest } from '@recruitee/gdpr-types';
import { HttpApiService } from '@recruitee/http';

export type GdprRequestReferences = CandidateReference | UserReference;

@Injectable({ providedIn: 'root' })
export class GdprRequestHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchCollection(
    candidateId: number,
  ): Observable<{ requests: GdprRequest[]; references: GdprRequestReferences[] }> {
    return this.httpApi.get(`gdpr/candidates/${candidateId}/requests`);
  }

  public complete(
    requestId: number,
  ): Observable<{ request: GdprRequest; references: GdprRequestReferences[] }> {
    return this.httpApi.post(`gdpr/requests/${requestId}/complete`);
  }
}
